import { createWishlist, getIds, getMyWishlist, getWishlist, removeItem, saveItem, transferWishlistToCustomer } from "@/generated/api/sdk.gen"
import type { Api } from "@/platform/api/api"
import { body, orNull } from "@/platform/api/gateways/common"

const PRODUCT_LIMIT = 100

export const wishlistGateway = (api: Api) => ({
  create: () => body(createWishlist(api.request())),

  mine: () => orNull(body(getMyWishlist(api.request()))),

  claim: (wishlistId: string) => body(transferWishlistToCustomer({ ...api.request(), path: { id: wishlistId } })),

  ids: (wishlistId: string) => orNull(body(getIds({ ...api.request(), path: { id: wishlistId } }))),

  products: async (wishlistId: string, regionId?: string) =>
    (await body(getWishlist({ ...api.request(), path: { id: wishlistId }, query: { limit: PRODUCT_LIMIT, ...(regionId ? { region_id: regionId } : {}) } }))).products,

  save: (wishlistId: string, productId: string) => body(saveItem({ ...api.request(), path: { id: wishlistId, productId } })),

  remove: (wishlistId: string, productId: string) => body(removeItem({ ...api.request(), path: { id: wishlistId, productId } })),
})

export type WishlistGateway = ReturnType<typeof wishlistGateway>
